<template>
  <div class="am-fund-popup">
    <div>
       <div class="am-fund-title-bar am-main-top-box">
         <span class="am-fund-title am-main-top-box-title"><strong>Fund</strong></span>
       </div>
        <table class="am-fund-table">
          <tbody>
          <tr>
            <td><strong><span>Tran Type:</span></strong></td>
            <select v-model="fund.premiumFinanceDetailsId" class="am-unfunded-dropdown">
              <option v-for="unfundedItem in unfundedItems" :value="unfundedItem.id" :key="unfundedItem.id">{{unfundedItem.type}} - {{unfundedItem.dateFinanced}} - ${{unfundedItem.amount}}</option>
            </select>
          </tr>
           <tr>
             <td><strong><span>Date Funded:</span></strong></td>
             <td>
               <input type="date" id="date-fund" class="input" v-model="fund.dateFinanced">
             </td>
           </tr>
           <tr>
             <td><strong><span>Amount Funded:</span></strong></td>
             <td>
               <money class="input" v-model="fund.amount" v-bind="money"></money>
             </td>
           </tr>
          </tbody>
        </table>
      <div class="am-fund-blue-border"></div>
      <div class="am-fund-align-bottom-buttons">
          <div class="am-fund-float-right">
           <button type="button" class="btn btn-primary" @click="submit" :disabled="disableSubmit">Submit</button>
           <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Money, VMoney } from 'v-money'
import api from './../http'
export default {
  name: 'Fund',
  data () {
    return {
      fund: {
        amount: 0,
        dateFinanced: '',
        premiumFinanceId: 0,
        premiumFinanceDetailsId: 0
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        masked: false
      }
    }
  },
  props: {
    financeId: Number,
    unfundedItems: Object
  },
  directives: {
    money: VMoney
  },
  mounted () {
    this.fund.premiumFinanceId = this.financeId

    this.fund.premiumFinanceDetailsId = this.unfundedItems[Object.keys(this.unfundedItems)[0]].id
  },
  computed: {
    disableSubmit() {
      return this.fund.dateFinanced === ''
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('fundDialog')
    },

    submit () {
      let self = this
      api.postRequest('customer/finance/fund/save/', this.fund).then(
        (data) => {
          this.$emit('refreshDetails', '')
          self.closeModal()
        })
    }
  },
  components: {
    Money
  }
}
</script>
<style scoped>
  .am-fund-popup{
    width: 100%;
  }
  .am-main-top-box{
    padding: 8px;
  }
  .am-main-top-box-title{
    font-size: 12px;
  }
  .am-fund-table {
    margin-top: 10px;
    margin-left: 12px;
  }
  .am-fund-table td input{
    margin-left: 50px;
    background-color: white;
    margin-top: 1px;
  }
  .am-fund-blue-border{
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 30px;
  }
  #date-fund {
    width: 147px;
    height: 22px;
  }
  .am-fund-align-bottom-buttons{
    padding: 5px 7px 9px 0px;
    float: right;
    margin-right: 5px;
}
  .btn-primary{
    padding: 2px 10px;
    font-size: 12px;
    margin-right: 5px;
  }
  .btn-secondary{
    padding: 2px 10px;
    font-size: 12px;
    margin-right: 3px;
  }
  .am-unfunded-dropdown {
    margin: 1px 0 0 51px;
    background-color: white;
  }
</style>
